import { Grid, styled } from '@mui/material';

export const GridWithBorder = styled(Grid)({
    borderRight: '1px solid #dee2e6',
});
